import { Navigate } from 'react-router-dom';

import { useResolvedAuthenticatedPath } from '../shared/hooks/use-employee-session';

export function IndexPage() {
  const redirectPath = useResolvedAuthenticatedPath();

  if (redirectPath === null) {
    return null;
  }

  return <Navigate replace to={redirectPath} />;
}
